import { QueryKey } from '@/Config/api/queryKey';

export const DISCORD_INTEGRATION_NAME = 'discord' as const;
export const DISCORD_QUERY_KEY = [QueryKey.integration.get, DISCORD_INTEGRATION_NAME] as const;

export const REPLY_MODE_THREADS = 'threads';
export const REPLY_MODE_CHANNEL = 'channel';

// Poll the Discord status every 2s while a restart is in flight, and never
// keep the spinner up longer than 20s — matching the legacy modal's window.
export const SYNC_POLL_INTERVAL_MS = 2_000;
export const SYNC_TIMEOUT_MS = 20_000;
// After the timeout, keep watching this long for a callback that arrives late.
export const LATE_CALLBACK_POLL_WINDOW_MS = 60_000;

export interface DiscordIntegrationParams {
  discord_bot_active: boolean;
  discord_bot_token: string | null;
  discord_bot_errors: string | null;
  discord_last_updated: string | null;
  discord_cross_channel_search_active: boolean;
  discord_respond_in_threads: boolean;
}

export interface DiscordIntegrationResponse {
  name: typeof DISCORD_INTEGRATION_NAME;
  discord_sync_pending?: boolean;
  params: DiscordIntegrationParams;
}
